import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import {
    fetchCompanyList,
    fetchCompanyListSuccess,
    fetchFilteredLocationList,
    fetchFilteredLocationListSuccess,
    setSurfaceDefaultsValidationConfirm,
    validateSurfaceDefaultsFailed,
    validateSurfaceDefaultsRequest,
    validateSurfaceDefaultsSuccess,
} from "./actions";
import { SurfaceDefaultsAPI, Request, APIError } from "@ai360/core";
// selectors
import { clearFilteredLocationList } from "./actions";
import { getTheUserGuid } from "~/login/selectors";
import { actions as notificationActions } from "~/notifications";
import { messages } from "../../i18n-messages";
import { setApiResult } from "~/core/api/actions";

function* processFetchCompanyList(action) {
    const UserGuid = yield select(getTheUserGuid);
    const requestOptions = { UserGuid };
    yield put(clearFilteredLocationList());
    try {
        const companyList = yield call(
            Request.post,
            SurfaceDefaultsAPI.GET_COMPANY_LIST,
            requestOptions
        );
        yield put(fetchCompanyListSuccess({ companyList }));
    } catch (error) {
        yield put(notificationActions.apiCallError(error, action, messages.fetchCompanyListError));
    }
}

export function* watchFetchCompanyList() {
    yield takeEvery(fetchCompanyList, processFetchCompanyList);
}

export function* processFetchFilteredLocationList(action) {
    const requestOptions = { Model: action.payload };
    try {
        const filteredLocationList = yield call(
            Request.post,
            SurfaceDefaultsAPI.REQUEST_FILTERED_LOCATION_LIST,
            requestOptions
        );
        yield put(fetchFilteredLocationListSuccess({ filteredLocationList }));
    } catch (error) {
        yield put(
            notificationActions.apiCallError(error, action, messages.fetchFilteredLocationListError)
        );
    }
}

export function* watchFilteredLocationList() {
    yield takeEvery(fetchFilteredLocationList, processFetchFilteredLocationList);
}

export function* processValidateSurfaceDefaults(action) {
    const requestModel = action.payload || {};
    const UserGuid = yield select(getTheUserGuid);
    const requestOptions = { UserGuid, Model: requestModel };

    try {
        yield call(Request.post, SurfaceDefaultsAPI.VALIDATE_SURFACE_DEFAULTS, requestOptions);
        yield put(validateSurfaceDefaultsSuccess());
    } catch (error) {
        const errorCodeList =
            error?.errorCodeList ||
            error?.apiResultObj?.errorCodeList ||
            error?.response?.errorCodeList ||
            [];

        if (errorCodeList.includes(936)) {
            yield put(setSurfaceDefaultsValidationConfirm(true));
            return;
        }

        if (error instanceof APIError) {
            yield put(setApiResult(error));
        }
        yield put(validateSurfaceDefaultsFailed({ error }));
    }
}

export function* watchValidateSurfaceDefaults() {
    yield takeEvery(validateSurfaceDefaultsRequest, processValidateSurfaceDefaults);
}

const SurfaceDefaultsSagas = function* () {
    yield all([
        fork(watchFetchCompanyList),
        fork(watchFilteredLocationList),
        fork(watchValidateSurfaceDefaults),
    ]);
};

export default SurfaceDefaultsSagas;
